import React from "react";
import styles from "./ClientNameRenderer.module.css";
import { ClientNameRendererProps } from "./ClientNameRenderer.utils";

/**
 * ClientNameRenderer Component
 *
 * Renders a button with a pencil icon to edit either the onboarding or acceptance form
 * for a given client. Displays the corresponding form name alongside the button.
 * On click, it sets the form ID, client ID, and opens the editor modal.
 */
const ClientNameRenderer: React.FC<ClientNameRendererProps> = ({
  data,
  setApprovalModalShow,
  setClientMasterId,
  setAttestFormId,
  setOnboardingFormId,
  setAuditAcceptanceFormId,
  setTaxAcceptanceFormId,
  setClientRecord,
  setFirmDetailId,
  transporter,
}) => {
  // const { formId, formName } = getFormDetails(formType, rowData);
  const clientName = data && data["ClientName"] ? data["ClientName"] : "Not Available"
  const viewClientDetails = () => {
    if (data.COIApprovalStatus === "CONFLICT" && data.MyPendingCOIReview === "Y" && transporter) {
      transporter("coi_conflict_check", {
        coi_conflict_check_option: { clientMasterId: data.ClientMasterId },
      });
      return;
    }
    setClientMasterId(data.ClientMasterId || 0);
    setAttestFormId(data.AttestFormId);
    setOnboardingFormId(data.OnboardingFormId);
    setTaxAcceptanceFormId(data.TaxAcceptanceFormId);
    setAuditAcceptanceFormId(data.AuditAcceptanceFormId);
    setApprovalModalShow(true);
    setFirmDetailId(data.FirmDetailId);
    setClientRecord(data)
  };
  return data ? (
    <div className={styles.editFormButtonWrapper} onClick={() => viewClientDetails()}>
      <div>{clientName ? clientName : "Not Available"}</div>
    </div>
  ) : (
    <>Not Available</>
  );
};

export default ClientNameRenderer;
